import { createApp, setup } from '@shared/setup'

import { logInfo } from '@shared/helpers/Logger'

// DATA
const instanceKey = '__vueInstance__'
const ROOT_EL = document.body
const observeConfig = { attributes: false, childList: true, subtree: true }

export async function registerContinuously(component, selector, props) {
  let nodes = document.querySelectorAll(selector)
  if (nodes.length) {
    for (const node of nodes) {
      await register(component, node, props)
    }
  }

  const observer = createObserver(async () => {
    nodes = Array.from(document.querySelectorAll(selector)).filter(node => {
      return !isVueAppMounted(node)
    })

    for (const node of nodes) {
      await register(component, node, props)
    }
  })

  observer.observe(ROOT_EL, observeConfig)
}

export function registerOnce(component, selector, props) {
  const el = document.querySelector(selector)

  if (el) {
    return register(component, el, props)
  }

  const observer = createObserver(() => {
    const node = document.querySelector(selector)

    // node present => register and cancel observer
    if (node) {
      register(component, node, props)
      observer.disconnect()
    }
  })

  observer.observe(ROOT_EL, observeConfig)
}

function createObserver(callback) {
  return new MutationObserver(async mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        await callback()
      }
    }
  })
}

function preProcessProps(element, props) {
  return props(element.dataset)
}

function isVueAppMounted(element) {
  return element.getAttribute(instanceKey)
}

function setVueAppMounted(element, uid) {
  element.setAttribute(instanceKey, uid)
}

async function register(component, element, props) {
  if (isVueAppMounted(element)) return

  props = props ? preProcessProps(element, props) : element.dataset

  const instance = await setup({
    appInstance: createApp(component, props),
    appName: 'webWidgets',
    languageGetter: () => {
      return document.querySelector('html').getAttribute('lang')?.toUpperCase()
    },
  })

  instance.mount(element)
  setVueAppMounted(element, instance._uid)

  logInfo(['%cMOUNTED WIDGET', 'color: green', instance._component.__name])
}
